'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinTeam = exports.createTeam = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeam = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var client = _interopRequireWildcard(_client);

var _pages = require('../../pages');

var _params = require('../../../utils/params');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  return {
    id: team.id,
    leader: team.team_leader_page_uid,
    name: team.name,
    owner: team.owner_uid,
    pages: team.team_member_uids,
    raised: (0, _get2.default)(team, 'amount.cents'),
    slug: team.slug,
    url: team.url
  };
};

var fetchTeams = exports.fetchTeams = function fetchTeams(args) {
  return (0, _pages.fetchPages)(_extends({ type: 'team', allPages: true }, args));
};

var fetchTeam = exports.fetchTeam = function fetchTeam() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return client.get('api/v2/pages/' + id).then(function (response) {
    return response.page;
  });
};

var createTeam = exports.createTeam = function createTeam(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? (0, _params.required)() : _ref$page,
      name = _ref.name;

  var payload = {
    individual_page_id: page,
    name: name
  };

  var options = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  };

  return client.post('api/v2/teams', payload, options).then(function (response) {
    return response.page;
  });
};

var joinTeam = exports.joinTeam = function joinTeam(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$page = _ref2.page,
      page = _ref2$page === undefined ? (0, _params.required)() : _ref2$page,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;

  var payload = {
    individual_page_id: page
  };

  var options = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  };

  return client.post('api/v2/teams/' + id + '/join-requests', payload, options).then(function (response) {
    return response.team;
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/teams/everydayhero/index.js
// module id = 1424
// module chunks = 0